import { State } from "../config/state.model";
import { IProperty } from "../interfaces/property/property.model.interface";
import { IState } from "../interfaces/config/state.model.interface";
import { IPropertyBlockBrand } from "../interfaces/property/property-block-brand.model.interface";
import { IProductCategory } from "../interfaces/product/product-category.model.interface";
import { IPropertyLeadSource } from "../interfaces/property/property-lead-source.model.interface";
import { IZone } from "../interfaces/zone/zone.model.interface";

export class Property implements IProperty {
    public propertyId: number;
    public propertyCode: string;
    public name: string;
    public publisherId: number;
    public publisherName: string;
    public domain: string;
    public allowConquest: boolean;
    public productCategoryThemeId: number;
    public state: IState;
    public blockedBrands: IPropertyBlockBrand[];
    public permittedCategories: IProductCategory[];
    public categories: IProductCategory[];
    public leadSources: IPropertyLeadSource[];
    public zones: IZone[];

    constructor() {
        this.propertyId = 0;
        this.propertyCode = "";
        this.name = "";
        this.publisherId = 0;
        this.publisherName = "";
        this.domain = "";
        this.allowConquest = true;
        this.productCategoryThemeId = 1;
        this.state = new State();
        this.blockedBrands = [];
        this.permittedCategories = [];
        this.categories = [];
        this.leadSources = [];
        this.zones = [];
    }
}
